import { getFailureReason, getIsCustomerCareApiPending, getQuoteForm } from '../../../selectors/ugMotorInsurance/quote';
import { apiTransitionSendCustomerCareMail } from '../../../actions/ugMotorInsurance/quote';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import { getPersonalDetailsForm } from '../../../selectors/ugMotorInsurance/personalDetails';

export const sendCustomerMailService = (store, next, action) => {
    (async () => {
        if (!getIsCustomerCareApiPending(store.getState())) {
            store.dispatch(apiTransitionSendCustomerCareMail.pending());
            try {
                await makeSubmission(store.getState());

                store.dispatch(apiTransitionSendCustomerCareMail.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionSendCustomerCareMail.failure());
            }
        }
    })();
    return next(action);
};

const getFullName = (quotation, personalDetails) => {
    const firstName = personalDetails.firstName?.value || quotation.firstName?.value || '';
    const middleName = personalDetails.middleName?.value || quotation.middleName?.value || '';
    const lastName = personalDetails.lastName?.value || quotation.lastName?.value || '';

    return [firstName, middleName, lastName].filter(Boolean).join(' ');
};

const sendMailPayload = (state) => {
    const personalDetails = getPersonalDetailsForm(state);
    const quotation = getQuoteForm(state);
    const fullName = getFullName(quotation, personalDetails);
    const failureReason = getFailureReason(state);

    const payload = {
        fullName,
        phoneNumber: personalDetails.phoneNumber?.value || '',
        email: personalDetails.email?.value || '',
        failureReason: failureReason || '',
    };

    return {
        ...payload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ug-motor-insurance/send/customer-support-mail';
        return await axios.post(url, sendMailPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
